import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ESignRoutingModule } from './e-sign-routing.module';
import { ESignParentComponent } from './e-sign-parent/e-sign-parent.component';
import { ESignFormComponent } from './e-sign-form/e-sign-form.component';
import { ESignUploadComponent } from './e-sign-upload/e-sign-upload.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { ESignRetriggerComponent } from './e-sign-retrigger/e-sign-retrigger.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';


@NgModule({
  declarations: [
    ESignParentComponent,
    ESignFormComponent,
    ESignUploadComponent,
    ESignRetriggerComponent,
  ],
  imports: [
    CommonModule,
    ESignRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    InputTextModule,
    ButtonModule,
    DialogModule
  ]
})
export class ESignModule { }
